import { areProductsEqual } from "@helpers/products/areProductsEqual";

import type { Product } from "@typings/product/product";

export const removeFromCart = (cartItems: Product[], removedCartItems: Product[]) => {
  return cartItems.reduce((acc, ci) => {
    const removedItem = removedCartItems.find((rci) => areProductsEqual(rci, ci));

    if (!removedItem) return [...acc, ci];

    const newQuantity = ci.configuration.quantity - removedItem.configuration.quantity;

    if (newQuantity <= 0) return acc;

    return [
      ...acc,
      {
        ...ci,
        configuration: {
          ...ci.configuration,
          quantity: newQuantity,
        },
      },
    ];
  }, [] as Product[]);
};
